module.exports = __webpack_public_path__ + "img/65.0eb599f6.png";